<template>
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-if="id > 0 && load == 2"
  />
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-else-if="id == 0 && load == 1"
  /> 
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    v-else-if="id == 0 && load == 2"
  /> 
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.permohonan.pd',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Permohonan Pembiakan Perkhidmatan', route: '/art/permohonan/form/0' },
      ],
      title : 'Permohonan Pembiakan Perkhidmatan',
      form : {
        id : 0,
        premis_id : '',
        nama_program : '',
        nama_premis : '',
        lokasi : '',
        waktu_program : '',
        tarikh_program_dari : '',
        tarikh_program_hingga : '',
        waktu_program : '',
        jumlah_periksa : '',
        jumlah_tidak_bunting : '',
        jumlah_bunting : '',
        juruteknik_id : false,
        pilih_jurutekni: [],   
        load: 0,
        id: 0,
        p : 0,
        ternakan_list : [],
      },
      premis_id : [],
      ternakan_list:[],
      premis : [],
      juruteknik_list : [],
      lkp_ternakan : [],
      lkp_status : [],
      art_pd : [],
      lkp_art : [],
      load : 0
      
      
    }
  },
  methods: {
     getData(){
        if(this.id > 0){
          this.$zcomm.get(this.api_service + 'art/show-program/' + this.id, {}).then(res => {
            this.form = res
            this.load = this.load + 1

            
            this.pilih_jurutekni = (res.pegawai || []).map((p, i) => {
              return {
                label: p.nama_pegawai,
                id: i
              }
            })
          })
        }
      },

    getSalin(id){
        this.$zcomm.get(this.api_service + 'art/show-program/'+id, {}).then(res => {
          this.form = res
          this.form.id = 0
          this.load = this.load + 1
        })

       
      },

    getNegeri(){
         this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.lkp_negeri = res
            this.load = this.load + 1
         })
    },

  
  },

  watch: {

  },
  mounted() {
    this.getData()
    this.getNegeri()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.salin && this.params.salin > 0){
      
      this.getSalin(this.params.salin)
    }
    
  }
    
}
</script>
